<template>
  <div>
    <h2 class="text-center font-weight-light">
      Sao lưu dữ liệu
    </h2>
    <v-dialog
      v-model="waiting"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="warning"
        dark
      >
        <v-card-text>
          Việc này có thể mất một vài phút...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card>
      <v-card-text class="mt-4">
        <div v-if="errors_exist" class="row">
          <div class="col">
            <v-alert
              dense
              outlined
              type="error"
            >
              {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
              <ul>
                <div v-for="(error, index) in errors">
                  <li :key="index">{{ error[0] }}</li>
                </div>
              </ul>
            </v-alert>
          </div>
        </div>
        <v-row>
          <v-col cols="12">
            <date-picker
              v-model="fromDate"
              :label="'Từ ngày'"
              :placeholder="'Từ ngày'"
              :outlined="true"
              :hideDetails="true"
            />
          </v-col>
          <v-col cols="12">
            <date-picker
              v-model="toDate"
              :label="'Đến ngày'"
              :placeholder="'Đến ngày'"
              :outlined="true"
              :hideDetails="true"
            />
          </v-col>
          <v-col
            v-for="(type, index) in types"
            :key="index"
            cols="12"
            sm="auto"
          >
            <v-checkbox
              v-model="dataType"
              :label="type.label"
              :value="type"
              hide-details
            />
          </v-col>
          <v-col
            cols="12"
            sm="auto"
          >
            <v-checkbox
              @change="checkAllChanged($event)"
              label="Chọn tất cả"
              value="all"
              color="orange"
              hide-details
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn 
          :disabled="dataType.length == 0"
          color="success"
          @click="backupData()"
          class="px-16"
        >
          <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
          <span>Tải về</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
  import { mapActions } from 'vuex';
  import DatePicker from '@/components/common/DatePicker.vue';
  import FileSevice from '@/services/File';
  export default {
    components: { 
      DatePicker
    },
    data () {
      return {
        types: [
          {label: "Thông tin nông nghiệp", key: "ttnn"},
          {label: "Giá cả thị trường", key: "gc"},
          {label: "Sản phẩm chuỗi", key: "spc"}
        ],
        fromDate: '',
        toDate: '',
        dataType: [],
        waiting: false,
        errors_exist: false,
        errors: []
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      checkAllChanged(val){
        const app = this;
        if(val) {
          app.dataType = [];
          app.types.forEach(function(value){
            app.dataType.push(value);
          });
        } else {
          app.types.forEach(function(value){
            app.dataType.shift(value);
          });
        }
      },
      backupData(){
        const app = this;
        app.waiting=true;
        axios.post(`api/v1/backupData`, {
          fromDate: app.fromDate,
          toDate: app.toDate,
          dataType: app.dataType
        }, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            var currDate = new Date();
            var fileName = `backup-${currDate.getDate()}-${(currDate.getMonth() + 1)}-${currDate.getFullYear()}`;
            FileSevice.download(response.data, `${fileName}.xlsx`);
            this.waiting=false;
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.waiting=false;
            app.openSnackbar({ type: 'error' });
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
            console.log(error)
          });
      }
    }
  }
</script>